import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberPopover from 'ember-tooltips/components/ember-popover';

interface SensitiveFieldsLockSignature {
  Element: HTMLSpanElement;
  Args: {
    // 'upgrade' → company lacks the `sensitive_fields` entitlement (non-Enterprise)
    // 'permission' → company is entitled but the user lacks the manage-sensitive permission
    variant: 'upgrade' | 'permission';
  };
}

/**
 * Lock icon + white hover card shown next to the "Sensitive fields" section when the user can't
 * manage it. EmberPopover keeps the card open on hover so the "Learn more" link (upgrade variant)
 * is clickable; it is portaled to <body> so the link isn't nested inside the surrounding `role="tab"`.
 */
export default class SensitiveFieldsLock extends Component<SensitiveFieldsLockSignature> {
  get message(): string {
    return this.args.variant === 'permission'
      ? "You don't have permission to manage sensitive fields. Contact your admin."
      : 'Upgrade to the Visitors Enterprise plan.';
  }

  get showLearnMore(): boolean {
    return this.args.variant === 'upgrade';
  }

  <template>
    <span
      class="relative inline-flex items-center align-middle ml-1 -top-0.5"
      role="img"
      aria-label={{this.message}}
      data-test-sensitive-fields-locked
      ...attributes
    >
      {{svgJar "lock-gray"}}
      {{! White hover card; z-index beats the modal (100000000) — 214748364 is the app's "in front of modal" value }}
      <EmberPopover
        @side="top"
        @popperContainer="body"
        @popoverHideDelay={{300}}
        @tooltipClass="!bg-white rounded-lg shadow-md border border-carbon-10 !text-carbon-80 text-sm text-shadow-none !max-w-96 !z-[214748364]"
      >
        {{this.message}}
        {{#if this.showLearnMore}}
          {{! TODO: destination for "Learn more" is TBD — kept as placeholder while behind the flag }}
          <a href="#" target="_blank" rel="noopener" class="!text-gem-50" data-test-sensitive-fields-learn-more>Learn
            more</a>
        {{/if}}
      </EmberPopover>
    </span>
  </template>
}
